import { Alert } from 'system/Alert/Alert';
export const NotFound = () => {
  return (
    <div>
      <Alert heading={{ id: 'not_found_heading' }} message={{ id: 'not_found_message' }} type="info" />
    </div>
  );
};
